import { Container, Row, Col, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BsPeopleFill, BsAward, BsClock, BsGlobe } from "react-icons/bs";
import "./about.css";
import img1 from './../../assets/about-1.jpeg'
import img2 from './../../assets/about-2.jpeg'
import img3 from './../../assets/about-3.jpeg'
import img4 from './../../assets/about-4.jpeg'

const timeline = [
  {
    year: "2021",
    title: "The Leap of Faith",
    desc: "JSR DigiMarketing was founded in Chennai with more belief than resources. Starting with just a laptop, internet connection, and a strong desire to help businesses grow, the early days were filled with learning, experimentation, and persistence. Every project was an opportunity, not just to deliver results, but to prove that digital marketing, when done right, can truly transform a business.",
    side: "left",
  },
  {
    year: "2023",
    title: "Earning Trust the Hard Way",
    desc: "Growth didn’t come overnight. It came through consistent effort, late nights, and a commitment to delivering value. As more businesses started seeing results, trust began to build. Referrals followed, relationships strengthened, and JSR DigiMarketing slowly became a reliable partner for businesses looking to grow online.",
    side: "right",
  },
  {
    year: "2025",
    title: "Finding Direction & Scale",
    desc: "With experience came clarity. What worked, what didn’t, and what truly drove results became sharper than ever. This phase was about refining strategies, focusing on performance, and building systems that could deliver consistent outcomes. The shift was clear from doing marketing to building growth engines for businesses.",
    side: "left",
  },
  {
    year: "Present",
    title: "Purpose-Driven Growth",
    desc: "Today, JSR DigiMarketing stands on a strong foundation built through persistence, learning, and real-world results. The mission remains unchanged, to help businesses grow with clarity, strategy, and measurable impact. Every campaign, every strategy, and every client relationship is driven by one goal: delivering marketing that actually works.",
    side: "right",
  },
];

const storyImages = [
  img1,
  img2,
  img3,
  img4,
];

export const About = () => (
  <>
    {/* ── Hero ── */}
    <section className="ab-hero">
      <div className="ab-hero-orb" />
      <Container className="position-relative z-1 text-center">
        <div className="hero-badge-wrap mb-4">
          <span className="hero-badge">
            <Badge className="badge-new">Digital Growth</Badge>
            Partner For Your Business
          </span>
        </div>
        <h1 className="ab-hero-title">About JSR DigiMarketing</h1>
        <p className="ab-hero-sub">
          We combine creativity, content and performance marketing to deliver
          scalable growth, stronger brand presence, and measurable results for
          businesses ready to move ahead of their competition.
        </p>
        <div className="hero-actions mt-4">
          <Link to="/contact" className="btn-get-in-touch-hero">
            Get More Leads <span className="arrow-icon">↗</span>
          </Link>
          <Link to="/services" className="btn-view-services">
            Our Services
          </Link>
        </div>
      </Container>
    </section>

    {/* ── Our Story ── */}
    <section className="ab-story">
      <Container>
        <Row className="align-items-center g-5">
          <Col xs={12} lg={6}>
            <h2 className="ab-story-title">Our Story</h2>
            <p className="ab-story-text">
              Founded in 2021 in Chennai, JSR DigiMarketing is a results-driven
              digital marketing agency committed to helping businesses grow with
              clarity, strategy, and measurable outcomes. We believe marketing
              should go beyond visibility, it should create real impact, drive
              meaningful engagement, and contribute directly to business growth.
            </p>
            <p className="ab-story-text">
              With a strong focus on understanding each client’s unique goals,
              we combine data-driven insights with creative execution to build a
              powerful and consistent online presence. Our approach is centered
              around precision, performance, and long-term value creation.
            </p>
          </Col>
          <Col xs={12} lg={6}>
            <div className="ab-story-grid">
              {storyImages.map((src, i) => (
                <div key={i} className="ab-story-img-wrap">
                  <img
                    src={src}
                    alt={`Team at work ${i + 1}`}
                    className="ab-story-img"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>

    {/* ── Stats ── */}
    <section className="sp-process">
      <Container>
        <div className="text-center mb-5">
          <h2 className="sp-process-title">Our Process</h2>
          <p className="sp-process-sub">
            A Structured Approach to Drive Real Business Growth
          </p>
        </div>
        <Row className="g-4 justify-content-center">
          {[
            {
              num: "01",
              title: "Listen",
              desc: "We take the time to understand your business, goals, challenges, and what success truly means for you.",
            },
            {
              num: "02",
              title: "Analyze",
              desc: "We evaluate your current online presence, study your competitors, and identify your target audience to uncover growth opportunities.",
            },
            {
              num: "03",
              title: "Strategize",
              desc: "We design a customized, ROI-focused digital marketing strategy tailored to reach and convert your ideal audience.",
            },
            {
              num: "04",
              title: "Create",
              desc: "We build a strong and consistent online presence with engaging content and high-impact creatives across the right platforms.",
            },
            {
              num: "05",
              title: "Execute",
              desc: "We launch, monitor, and continuously optimize campaigns to generate quality leads, improve performance, and maximize your returns.",
            },
          ].map((step, i) => (
            <Col key={i} xs={12} sm={6} lg={4} className="text-center mb-5">
              <div className="sp-step-num">{step.num}</div>
              <h3 className="sp-step-title">{step.title}</h3>
              <p className="sp-step-desc">{step.desc}</p>
            </Col>
          ))}
        </Row>
      </Container>
    </section>

    {/* ── Timeline ── */}
    <section className="ab-timeline-section">
      <Container>
        <div className="text-center mb-5">
          <h2 className="ab-timeline-heading">Our Journey</h2>
          <p className="ab-timeline-sub">
            The milestones that shaped us into who we are today
          </p>
        </div>

        <div className="ab-timeline">
          <div className="ab-timeline-line" />
          {timeline.map((t, i) => (
            <div key={i} className={`ab-tl-row ab-tl-row--${t.side}`}>
              <div className="ab-tl-card">
                <p className="ab-tl-year">{t.year}</p>
                <p className="ab-tl-title">{t.title}</p>
                <p className="ab-tl-desc">{t.desc}</p>
              </div>
              <div className="ab-tl-dot" />
            </div>
          ))}
        </div>
      </Container>
    </section>

    {/* ── CTA ── */}
    <section className="ab-cta">
      <div className="ab-cta-orb" />
      <Container className="position-relative z-1 text-center">
        <h2 className="ab-cta-title">Ready to Grow Your Business?</h2>
        <p className="ab-cta-sub">
          Let’s connect and build a strategy that attracts the right audience and converts them into customers.
        </p>
        <Link to="/contact" className="ab-cta-btn">
          Get Started <BsPeopleFill />
        </Link>
      </Container>
    </section>
  </>
);
